<template>
  <v-container fluid>
    <v-card id="account-setting-card" flat>
      <!-- tabs -->
      <v-tabs v-model="tab" show-arrows elevation="1">
        <v-tab v-for="tab in tabs" :key="tab.icon">
          <v-icon size="20" class="me-3">
            {{ tab.icon }}
          </v-icon>
          <span>{{ tab.title }}</span>
        </v-tab>
      </v-tabs>
      <v-divider />
      <!-- tabs item -->
      <v-tabs-items v-model="tab" flat>
        <v-tab-item>
          <AccountSettings :accountData="accountSettingData" />
        </v-tab-item>

        <v-tab-item>
          <account-settings-security></account-settings-security>
        </v-tab-item>

        <v-tab-item>
          <account-settings-info
            :informationData="accountSettingData"
          ></account-settings-info>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import {
  mdiAccountOutline,
  mdiLockOpenOutline,
  mdiInformationOutline,
} from "@mdi/js";
import AccountSettings from "./AccountSettings";
import AccountSettingsInfo from "./AccountSettingsInfo";
import AccountSettingsSecurity from "./AccountSettingsSecurity";

export default {
  name: "SettingProfileCard",
  components: {
    AccountSettings,
    AccountSettingsInfo,
    AccountSettingsSecurity,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.dispatch("Setting/addRecentActivity", {
        subject: "You currently visited the account settings page",
      });
      vm.$store.dispatch("Setting/currentUser");
    });
  },
  data() {
    const tab = "";
    // tabs
    const tabs = [
      { title: "Account", icon: mdiAccountOutline },
      { title: "Security", icon: mdiLockOpenOutline },
      // { title: "Info", icon: mdiInformationOutline },
    ];
    return {
      tab,
      tabs,
      icons: {
        mdiAccountOutline,
        mdiLockOpenOutline,
        mdiInformationOutline,
      },
    };
  },
  computed: {
    accountSettingData() {
      return this.$store.getters["Profile/bioData"];
    },
  },
};
</script>
